var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _circle, _circle2, _ellipse, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 120,
    viewBox: "0 0 123 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5898 23.0625H112.253L104.57 89.139L29.2732 87.6023L21.5898 23.0625Z",
    fill: "#4ABBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5781 23.0625H112.141L104.458 89.139L67.5781 87.6023V23.0625Z",
    fill: "#009BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.16016H18.44L29.1966 85.9933",
    stroke: "#39689E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.643 86.041H29.5898C25.1716 86.041 21.5898 89.6227 21.5898 94.041V96.481C21.5898 100.899 25.1716 104.481 29.5898 104.481H106.133",
    stroke: "#3F6088",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5781 86.041H107.531M67.5781 104.481H106.723",
    stroke: "#224370",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.125,
    y: 64.6074,
    width: 9.21998,
    height: 9.21997,
    fill: "#39689E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6055,
    y: 64.6074,
    width: 9.21998,
    height: 9.21997,
    fill: "#39689E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.9492,
    y: 64.6074,
    width: 9.21998,
    height: 9.21997,
    fill: "#39689E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5935,
    cy: 112.205,
    r: 7.68331,
    fill: "#4ABBEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.4489,
    cy: 112.205,
    r: 7.68331,
    fill: "#009BE5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.486,
    cy: 21.5133,
    rx: 21.5133,
    ry: 21.5133,
    fill: "#83E470"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.927 21.5133C122.927 33.3947 113.296 43.0266 101.414 43.0266C101.414 43.0266 101.414 33.3947 101.414 21.5133C101.414 9.63182 101.414 0 101.414 0C113.296 0 122.927 9.63182 122.927 21.5133Z",
    fill: "#01B763"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.25 23.5705L96.804 26.9864C97.0947 27.2044 97.4584 27.3016 97.819 27.2577C98.1797 27.2139 98.5095 27.0324 98.7395 26.7512L109.153 15.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartDone);
export default __webpack_public_path__ + "static/media/CartDone.49f07a00bb1042b41d533da51473b8d4.svg";
export { ForwardRef as ReactComponent };